<template>
  <img :src="poster | posterImage(size)" />
</template>

<script>
export default {
  name: 'Poster',
  filters: {
    posterImage: (value, size) => {
      if (!value || !size) return;
      // return '/images/placeholder.png';
      // s592 s166
      return `https://images.justwatch.com${value.replace('{profile}', size)}`;
    },
  },
  props: {
    poster: {
      type: String,
      default: () => '/images/placeholder.png',
    },
    size: {
      type: String,
      default: () => 's166',
    },
  },
};
</script>

<style lang="scss">
img {
  width: 100%;
  box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.2);
  border-radius: 6px;
}
</style>
